import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import * as Rx from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map } from 'rxjs/operators';
import { AppSettingService, AppService, AppUtilityService } from '../app.service';
import { UserInfoService} from '../user/user-info.service';
import { CollegeScorecardAPIService, CollegeScorecardService } from './college-scorecard.service';
import { TerritoryCardService, ITerritoryCard } from '../territoryCard/territory-card.service';

@Component({
	selector: 'app-college-scorecard-search',
	templateUrl: './college-scorecard-search.component.html',
	styleUrls: ['../territoryCard/territory-card.scss'],
	standalone: false
})
export class CollegeScorecardSearchComponent implements OnInit {
	constructor(
		private appSrv: AppService,
		private CSCAPI: CollegeScorecardAPIService,
		public CSCSrv: CollegeScorecardService,
		private tcs: TerritoryCardService,
		private userInfo: UserInfoService
	) {}

	mobileView: boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.mobileView = AppSettingService.widgetMobile();
	}

	private monitorSearchFilterLoad(): void {
		// if all filters are loaded, then perform a search if needed.
		if (this.CSCSrv.degreeOptions.length > 0
			&& this.CSCSrv.stateOptions.length > 0
			&& this.CSCSrv.regionOptions.length > 0
			&& this.CSCSrv.studentSizeOptions.length > 0
			&& this.CSCSrv.schoolTypeOptions.length > 0
			&& this.CSCSrv.specializedMissionOptions.length > 0
			&& this.CSCSrv.religiousAffiliationOptions.length > 0
		) {
			if (this.CSCSrv.urlFilter.hasFilter && this.CSCSrv.searchResult.Schools.length === 0) {
				this.searchSchool();
			}
		}
	}

	//#region search selections
	private getDegree(): void {
		if (this.CSCSrv.degreeOptions.length == 0) {
			this.CSCAPI.getDegree().subscribe({
				next: (response: any) => {
					this.CSCSrv.degreeOptions = response;
					this.CSCSrv.searchFilter.Degree = {};
					for (var i = 0; i < this.CSCSrv.degreeOptions.length; i++) {
						this.CSCSrv.searchFilter.Degree[this.CSCSrv.degreeOptions[i].Value] = false;
					}
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getState(): void {
		if (this.CSCSrv.stateOptions.length === 0) {
			this.CSCAPI.getState().subscribe({
				next: (response: any) => {
					this.CSCSrv.stateOptions = response;
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getRegion(): void {
		if (this.CSCSrv.regionOptions.length == 0) {
			this.CSCAPI.getRegion().subscribe({
				next: (response: any) => {
					this.CSCSrv.regionOptions = response;
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getStudentSize(): void {
		if (this.CSCSrv.studentSizeOptions.length == 0) {
			this.CSCAPI.getStudentSize().subscribe({
				next: (response: any) => {
					this.CSCSrv.studentSizeOptions = response;
					this.CSCSrv.searchFilter.StudentSize = {};
					for (var i = 0; i < this.CSCSrv.studentSizeOptions.length; i++) {
						this.CSCSrv.searchFilter.StudentSize[this.CSCSrv.studentSizeOptions[i].Value] = false;
					}
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getSchoolType(): void {
		if (this.CSCSrv.schoolTypeOptions.length == 0) {
			this.CSCAPI.getSchoolType().subscribe({
				next: (response: any) => {
					this.CSCSrv.schoolTypeOptions = response;
					this.CSCSrv.searchFilter.SchoolType = {};
					for (var i = 0; i < this.CSCSrv.schoolTypeOptions.length; i++) {
						this.CSCSrv.searchFilter.SchoolType[this.CSCSrv.schoolTypeOptions[i].Value] = false;
					}
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getUrbanicity(): void {
		if (this.CSCSrv.urbanicityOptions.length == 0) {
			this.CSCAPI.getUrbanicity().subscribe({
				next: (response: any) => {
					this.CSCSrv.urbanicityOptions = response;
					this.CSCSrv.searchFilter.Urbanicity = {};
					for (var i = 0; i < this.CSCSrv.urbanicityOptions.length; i++) {
						this.CSCSrv.searchFilter.Urbanicity[this.CSCSrv.urbanicityOptions[i].Value] = false;
					}
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getSpecializedMission(): void {
		if (this.CSCSrv.specializedMissionOptions.length == 0) {
			this.CSCAPI.getSpecializedMission().subscribe({
				next: (response: any) => {
					this.CSCSrv.specializedMissionOptions = response;
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	private getReligiousAffiliation(): void {
		if (this.CSCSrv.religiousAffiliationOptions.length == 0) {
			this.CSCAPI.getReligiousAffiliation().subscribe({
				next: (response: any) => {
					this.CSCSrv.religiousAffiliationOptions = response;
					this.monitorSearchFilterLoad();
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.monitorSearchFilterLoad();
		}
	}

	studentSize(v: any): string {
		return this.CSCSrv.studentSize(v);
	}

	cost(v: string, navg: string): string {
		return this.CSCSrv.cost(v, navg);
	}

	graduationRate(v: string, navg: string): string {
		return this.CSCSrv.graduationRate(v, navg);
	}

	salary(v: string, navg: string): string {
		return this.CSCSrv.salary(v, navg);
	}

	searchResultTotal(): number {
		return this.CSCSrv.searchResult.Total === null ? null : parseInt(this.CSCSrv.searchResult.Total);
	}
	//#endregion search selections

	//#region perform search
	flagFromViewAll: boolean = true;
	convertSchool(school: any): ITerritoryCard {
		return this.tcs.normalizeInstitution(school);
	}
	
	private submitSearch(): void {
		// when enableReset is false, system is doing search, make sure search is serialized
		if (!this.enableReset) {
			return;
		}
		this.enableReset = false;
		this.CSCAPI.searchSchool(this.CSCSrv.searchOption).subscribe({
			next: (response: any) => {
				// ignore the response if the page is not current desired page
				if (response.Metadata.Page + 1 == this.CSCSrv.searchResult.CurrentPage) {
					if (response.Results.length > 0) {
						this.CSCSrv.searchResult.Status = 2;
						this.CSCSrv.searchResult.Page = response.Metadata.Page;
						this.CSCSrv.searchResult.Total = response.Metadata.Total;
						this.CSCSrv.searchResult.Schools = response.Results;
						this.CSCSrv.searchResult.Message = "";
						// auto scroll to the top of search result
						try {
							document.getElementById("divCSCSearchResult").scrollIntoView();
							//journey top navigation is floating div, so we need to move up more pixel
							window.scrollTo(0, window.scrollY - 40);
						}
						catch (ex) { console.log(ex); }
					}
					else {
						this.CSCSrv.searchResult.Status = 3;
						this.CSCSrv.searchResult.Page = 0;
						this.CSCSrv.searchResult.Total = null;
						this.CSCSrv.searchResult.Schools = [];
						this.CSCSrv.searchResult.Message = "Oops! There is no data for the provided ZIP code: " + this.CSCSrv.searchOption.ZipCode + "!"
					}
				}
				this.enableReset = true;
			},
			error: (err: any) => {
				console.log(err);
				this.CSCSrv.searchResult.Status = 3;
				this.CSCSrv.searchResult.Page = 0;
				this.CSCSrv.searchResult.Total = null;
				this.CSCSrv.searchResult.Schools = [];
				this.CSCSrv.searchResult.Message = AppSettingService.noDataMessage;
				this.enableReset = true;
			}
		});
	}

	changeSearchPage(): void {
		this.CSCSrv.searchOption.Page = this.CSCSrv.searchResult.CurrentPage - 1;
		this.submitSearch();
	}

	searchSchool(): void {
		this.CSCSrv.searchOption.Page = 0;
		this.CSCSrv.searchOption.SchoolName = this.CSCSrv.searchFilter.SchoolName;
		this.CSCSrv.searchOption.Program = this.CSCSrv.searchFilter.Program;
		this.CSCSrv.searchOption.Degree = "";
		for (var property in this.CSCSrv.searchFilter.Degree) {
			if (this.CSCSrv.searchFilter.Degree[property]) {
				this.CSCSrv.searchOption.Degree += property + ","
			}
		}
		this.CSCSrv.searchOption.State = this.CSCSrv.searchFilter.State;
		this.CSCSrv.searchOption.Region = this.CSCSrv.searchFilter.Region;
		this.CSCSrv.searchOption.ZipCode = this.CSCSrv.searchFilter.ZipCode;
		this.CSCSrv.searchOption.Mile = this.CSCSrv.searchFilter.Mile;
		this.CSCSrv.searchOption.StudentSize = "";
		for (var property in this.CSCSrv.searchFilter.StudentSize) {
			if (this.CSCSrv.searchFilter.StudentSize[property]) {
				this.CSCSrv.searchOption.StudentSize += property + ","
			}
		}
		this.CSCSrv.searchOption.SchoolType = "";
		for (var property in this.CSCSrv.searchFilter.SchoolType) {
			if (this.CSCSrv.searchFilter.SchoolType[property]) {
				this.CSCSrv.searchOption.SchoolType += property + ","
			}
		}
		this.CSCSrv.searchOption.Urbanicity = "";
		for (var property in this.CSCSrv.searchFilter.Urbanicity) {
			if (this.CSCSrv.searchFilter.Urbanicity[property]) {
				this.CSCSrv.searchOption.Urbanicity += property + ","
			}
		}
		this.CSCSrv.searchOption.SpecializedMission = this.CSCSrv.searchFilter.SpecializedMission;
		this.CSCSrv.searchOption.ReligiousAffiliation = this.CSCSrv.searchFilter.ReligiousAffiliation;
		this.CSCSrv.searchResult.Status = 1;
		this.CSCSrv.searchResult.Page = 0;
		this.CSCSrv.searchResult.CurrentPage = 1;
		this.CSCSrv.searchResult.Total = null;
		this.submitSearch();
	}
	//#endregion perform search

	//#region school name lookup
	searchSchoolNameInput(val: any) {
		return (val.Name) ? val.Name : val;
	}

	@ViewChild('schoolNameSearchBox') schoolNameSearchBox: ElementRef;
	searchSchoolNameFocus(e: any): void {
		this.schoolNameSearchBox.nativeElement.dispatchEvent(new Event('input'));
		this.schoolNameSearchBox.nativeElement.focus();
	}

	blurSchoolNameSelection() {
		if (typeof (this.CSCSrv.searchFilter.selectedSchool) !== "object") {
			this.CSCSrv.searchFilter.selectedSchool = null;
			this.CSCSrv.searchFilter.SchoolName = "";
		}
	}

	selectSchoolName(f: any) {
		if (f != null && f.item != null) {
			let item = f.item;
			this.CSCSrv.initSearchFilter();
			this.CSCSrv.searchFilter.selectedSchool = item;
			this.CSCSrv.searchFilter.SchoolName = f.item.Name;
		}
	}

	searchSchoolName = (text$: Rx.Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(name => 
				(name.trim().length < 1) ?
					[] :
					this.CSCAPI
						.searchSchoolName({ Page: 0, PerPage: 5, SchoolName: name.trim() })
						.pipe(
							map(response => response.Results)
						)
			),
			catchError(err => Rx.of(console.log(err)))
		);
	//#endregion school name lookup

	//#region Academic Fields (program) lookup
	searchProgramInput(val: any) {
		return (val.Title) ? val.Title : val;
	}

	@ViewChild('programSearchBox') programSearchBox: ElementRef;
	searchProgramFocus(e: any): void {
		this.programSearchBox.nativeElement.dispatchEvent(new Event('input'));
		this.programSearchBox.nativeElement.focus();
	}

	blurProgramSelection() {
		if (typeof (this.CSCSrv.searchFilter.selectedProgram) !== "object") {
			this.CSCSrv.searchFilter.selectedProgram = null;
			this.CSCSrv.searchFilter.Program = "";
		}
	}

	selectProgram(f: any) {
		if (f != null && f.item != null) {
			this.CSCSrv.searchFilter.Program = f.item.CIPCode;
		}
	}

	searchProgram = (text$: Rx.Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(title => (title.trim().length < 1) ? [] : this.CSCAPI.searchDegree(title, "", 5, 0)),
			catchError(err => Rx.of(console.log(err)))
		);

	preSelectProgram() {
		if (this.CSCSrv.searchFilter.Program.length > 0) {
			this.CSCAPI.searchDegree("", this.CSCSrv.searchFilter.Program, 1, 0).subscribe({
				next: (response:any) => {
					this.CSCSrv.searchFilter.selectedProgram = response[0];
					this.CSCSrv.searchFilter.Program = response[0].CIPCode;
					this.searchSchool();
				},
				error:(err:any) => { console.log(err); }
			});
		}
	}
	//#endregion Academic Fields lookup

	// reset filter
	enableReset: boolean = true;
	resetFilter(): void {
		this.appSrv.redirectReload(
			"/CollegeScorecard/Search",
			{
				queryParams: {
					FromName: this.CSCSrv.urlFilter.FromName,
					FromURL: this.CSCSrv.urlFilter.FromURL,
					ZipCode: this.CSCSrv.urlFilter.ZipCode,
					Mile: this.CSCSrv.urlFilter.Mile,
					Program: this.CSCSrv.urlFilter.Program,
					SchoolName: this.CSCSrv.urlFilter.SchoolName,
					tm: AppUtilityService.newId()
				}
			}
		);
	}

	ngOnInit(): void {
		this.userInfo.enforceLogin();
		this.CSCSrv.gatherUrlFilter();
		this.preSelectProgram();
		this.getDegree();
		this.getState();
		this.getRegion();
		this.getStudentSize();
		this.getSchoolType();
		this.getUrbanicity();
		this.getSpecializedMission();
		this.getReligiousAffiliation();
	}
}


